import {makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

export enum ConversationTeamStatusesEnum {
  OPEN = 'open',
  ARCHIVED = 'archived',
  TRASHED = 'trashed',
  SPAM = 'spam',
  INVISIBLE = 'invisible',
  DESTROYED = 'destroyed',
}

export enum ConversationSortPropertiesEnum {
  BUMPED_AT = 'date',
  WAITING_SINCE = 'waiting_since',
  LAST_ACTIVITY_DATE = 'last_activity_at',
  LAST_MESSAGE_OR_COMMENT_DATE = 'last_comment_or_reply_at',
  EXPIRES_AT = 'expires_at',
}

export enum ConversationOrdersSortPropertiesEnum {
  BUMPED_AT = 'date',
  WAITING_SINCE = 'waiting_since',
  LAST_ACTIVITY_DATE = 'last_activity_at',
  LAST_MESSAGE_OR_COMMENT_DATE = 'last_comment_or_reply_at',
}

export const RConversationSortProperty = makeEnumRuntimeType(ConversationSortPropertiesEnum);
export const RConversationOrdersSortProperty = makeEnumRuntimeType(ConversationOrdersSortPropertiesEnum);

/*
 * Constants.
 */

/** Sort properties that are in the past. (Snooze expiration is in the future.) */
export const conversationSortPropertiesInPast = new Set<ConversationSortPropertiesEnum>([
  ConversationSortPropertiesEnum.BUMPED_AT,
  ConversationSortPropertiesEnum.WAITING_SINCE,
  ConversationSortPropertiesEnum.LAST_ACTIVITY_DATE,
  ConversationSortPropertiesEnum.LAST_MESSAGE_OR_COMMENT_DATE,
]);

export type ConversationId = number;
export type BumpedAtTimestamp = number;

export enum ConversationActionContextsEnum {
  TEAMMATE = 'teammate',
  TEAM = 'team',
  ASSIGNEE = 'assignee',
}
